import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-1 overflow-y-auto p-6"
};
const _hoisted_2 = {
  class: "space-y-6"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  class: "grid grid-cols-4 gap-2"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  key: 0,
  class: "relative rounded-lg overflow-hidden border border-slate-200"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 2,
  class: "relative inline-block"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "grid grid-cols-2 gap-4 mt-3"
};
const _hoisted_14 = {
  class: "flex items-center gap-3"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 1,
  class: "w-4 h-4 text-slate-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_17 = {
  class: "grid grid-cols-2 gap-4"
};
const _hoisted_18 = {
  class: "col-span-2"
};
const _hoisted_19 = {
  class: "col-span-2"
};
const _hoisted_20 = {
  class: "space-y-3"
};
const _hoisted_21 = {
  class: "flex items-center gap-2 cursor-pointer"
};
const _hoisted_22 = ["checked"];
const _hoisted_23 = {
  key: 0,
  class: "grid grid-cols-2 gap-4 ml-6"
};
const _hoisted_24 = {
  class: "px-6 py-4 border-t border-slate-200 flex items-center justify-end gap-3 shrink-0"
};
const _hoisted_25 = ["disabled"];
import { ref, reactive, watch, computed, nextTick } from 'vue';
import { ElMessage } from 'element-plus';
import { uploadFile } from '@/api/file';
import { compressImage } from '@/utils/imageCompress';
import { getAvailableOfficialPublishers } from '@/api/circle';
import OfficialPublisherPicker from './OfficialPublisherPicker.vue';
import OfficialPublisherManageModal from './OfficialPublisherManageModal.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'CirclePublishModal',
  props: {
    show: Boolean
  },
  emits: ['update:show', 'confirm'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      contentType: 1,
      content: '',
      images: '',
      videoUrl: '',
      videoCover: '',
      publisherName: '',
      publisherAvatar: '',
      linkUrl: '',
      linkTitle: '',
      isTop: 0,
      topSort: 0,
      topExpireTime: ''
    });
    const submitting = ref(false);
    const imageInput = ref();
    const videoInput = ref();
    const coverInput = ref();
    const avatarInput = ref();

    // 本地待上传文件
    const pendingImages = ref([]);
    const pendingVideoFile = ref(null);
    const pendingCoverFile = ref(null);
    const pendingAvatarFile = ref(null);
    const avatarPreview = ref('');
    const isImageText = computed(() => form.contentType === 1);
    const isVideo = computed(() => form.contentType === 2);

    // 官方发布者快捷选择
    const availablePublishers = ref([]);
    const publishersLoading = ref(false);
    const selectedPublisherId = ref(null);
    const showPublisherManageModal = ref(false);
    let publisherRequestSequence = 0;
    const loadAvailablePublishers = async ({
      validateSelection = false
    } = {}) => {
      const requestSequence = ++publisherRequestSequence;
      publishersLoading.value = true;
      try {
        const data = await getAvailableOfficialPublishers();
        if (requestSequence !== publisherRequestSequence) return;
        availablePublishers.value = Array.isArray(data) ? data : [];
        if (validateSelection && selectedPublisherId.value != null) {
          const stillAvailable = availablePublishers.value.some(item => item.id === selectedPublisherId.value);
          if (!stillAvailable) {
            selectedPublisherId.value = null;
            ElMessage.warning('已选官方发布者已停用或删除，请重新确认发布者信息');
          }
        }
      } catch {
        if (requestSequence === publisherRequestSequence) {
          availablePublishers.value = [];
          ElMessage.warning('官方发布者加载失败，可继续手工填写');
        }
      } finally {
        if (requestSequence === publisherRequestSequence) {
          publishersLoading.value = false;
        }
      }
    };
    watch(() => props.show, val => {
      if (val) {
        resetForm();
        nextTick(() => loadAvailablePublishers());
      } else {
        publisherRequestSequence++;
        selectedPublisherId.value = null;
      }
    });
    const resetForm = () => {
      Object.assign(form, {
        contentType: 1,
        content: '',
        images: '',
        videoUrl: '',
        videoCover: '',
        publisherName: '',
        publisherAvatar: '',
        linkUrl: '',
        linkTitle: '',
        isTop: 0,
        topSort: 0,
        topExpireTime: ''
      });
      pendingImages.value = [];
      pendingVideoFile.value = null;
      pendingCoverFile.value = null;
      pendingAvatarFile.value = null;
      avatarPreview.value = '';
      selectedPublisherId.value = null;
    };

    // ===== 图片处理 =====
    const triggerImageUpload = () => imageInput.value?.click();
    const handleImageChange = async event => {
      const files = Array.from(event.target.files);
      if (!files.length) return;
      for (const file of files) {
        if (!file.type.startsWith('image/')) {
          ElMessage.warning('请选择图片文件');
          continue;
        }
        if (file.size > 10 * 1024 * 1024) {
          ElMessage.warning('图片大小不能超过10MB');
          continue;
        }
        if (pendingImages.value.length >= 9) {
          ElMessage.warning('最多上传9张图片');
          break;
        }
        const compressed = await compressImage(file);
        pendingImages.value.push({
          file: compressed,
          preview: URL.createObjectURL(compressed)
        });
      }
      event.target.value = '';
    };
    const removeImage = index => {
      URL.revokeObjectURL(pendingImages.value[index].preview);
      pendingImages.value.splice(index, 1);
    };

    // ===== 视频处理 =====
    const triggerVideoUpload = () => videoInput.value?.click();
    const handleVideoChange = event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('video/')) {
        ElMessage.warning('请选择视频文件');
        return;
      }
      if (file.size > 100 * 1024 * 1024) {
        ElMessage.warning('视频大小不能超过100MB');
        return;
      }
      pendingVideoFile.value = {
        file,
        preview: URL.createObjectURL(file)
      };
      event.target.value = '';
    };
    const removeVideo = () => {
      if (pendingVideoFile.value?.preview) {
        URL.revokeObjectURL(pendingVideoFile.value.preview);
      }
      pendingVideoFile.value = null;
    };

    // ===== 视频封面处理 =====
    const triggerCoverUpload = () => coverInput.value?.click();
    const handleCoverChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }
      const compressed = await compressImage(file);
      pendingCoverFile.value = {
        file: compressed,
        preview: URL.createObjectURL(compressed)
      };
      event.target.value = '';
    };
    const removeCover = () => {
      if (pendingCoverFile.value?.preview) {
        URL.revokeObjectURL(pendingCoverFile.value.preview);
      }
      pendingCoverFile.value = null;
    };

    // ===== 头像处理 =====
    const triggerAvatarUpload = () => avatarInput.value?.click();
    const handleAvatarChange = async event => {
      const file = event.target.files[0];
      if (!file) return;
      if (!file.type.startsWith('image/')) {
        ElMessage.warning('请选择图片文件');
        return;
      }
      const compressed = await compressImage(file);
      pendingAvatarFile.value = compressed;
      avatarPreview.value = URL.createObjectURL(compressed);
      event.target.value = '';
    };

    // 官方发布者选择：设置来源ID并填充昵称、头像
    const handlePublisherSelect = publisher => {
      selectedPublisherId.value = publisher.id;
      form.publisherName = publisher.nickname;
      form.publisherAvatar = publisher.avatarUrl;
      // 释放旧本地头像预览并清空待上传头像
      if (avatarPreview.value && avatarPreview.value.startsWith('blob:')) {
        URL.revokeObjectURL(avatarPreview.value);
      }
      avatarPreview.value = publisher.avatarUrl;
      pendingAvatarFile.value = null;
    };

    // 管理弹窗变更时重新加载可用列表并校验当前选择
    const handleManageChanged = () => {
      loadAvailablePublishers({
        validateSelection: true
      });
    };
    const handleClose = () => {
      emit('update:show', false);
    };
    const handleSubmit = async () => {
      // 校验
      if (isImageText.value && pendingImages.value.length === 0 && !form.content.trim()) {
        return ElMessage.warning('请输入动态内容或上传图片');
      }
      if (isVideo.value && !pendingVideoFile.value) {
        return ElMessage.warning('请上传视频');
      }
      submitting.value = true;
      try {
        // 上传图片
        let images = '';
        if (isImageText.value && pendingImages.value.length > 0) {
          const urls = [];
          for (const img of pendingImages.value) {
            const result = await uploadFile(img.file, 'circle', 'public');
            urls.push(result.url || result);
          }
          images = urls.join(',');
        }

        // 上传视频
        let videoUrl = '';
        if (isVideo.value && pendingVideoFile.value) {
          const result = await uploadFile(pendingVideoFile.value.file, 'circle', 'public');
          videoUrl = result.url || result;
        }

        // 上传视频封面
        let videoCover = '';
        if (isVideo.value && pendingCoverFile.value) {
          const result = await uploadFile(pendingCoverFile.value.file, 'circle', 'public');
          videoCover = result.url || result;
        }

        // 上传头像
        let publisherAvatar = '';
        if (pendingAvatarFile.value) {
          const result = await uploadFile(pendingAvatarFile.value, 'circle', 'public');
          publisherAvatar = result.url || result;
        }
        const data = {
          contentType: form.contentType,
          content: form.content || undefined,
          images: images || undefined,
          videoUrl: videoUrl || undefined,
          videoCover: videoCover || undefined,
          officialPublisherId: selectedPublisherId.value || undefined,
          publisherName: form.publisherName || undefined,
          publisherAvatar: publisherAvatar || form.publisherAvatar || undefined,
          linkUrl: form.linkUrl || undefined,
          linkTitle: form.linkTitle || undefined,
          isTop: form.isTop,
          topSort: form.isTop === 1 ? form.topSort : undefined,
          topExpireTime: form.isTop === 1 && form.topExpireTime ? form.topExpireTime : undefined
        };
        emit('confirm', data);
      } catch (error) {
        ElMessage.error('文件上传失败');
        submitting.value = false;
      }
    };
    const done = () => {
      submitting.value = false;
      handleClose();
    };
    const fail = async () => {
      submitting.value = false;
      if (selectedPublisherId.value != null) {
        await loadAvailablePublishers({
          validateSelection: true
        });
      }
    };
    __expose({
      done,
      fail
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "3xl",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "px-6 py-4 border-b border-slate-200 flex items-center justify-between shrink-0"
          }, [_cache[12] || (_cache[12] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "发布动态", -1)), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[11] || (_cache[11] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode(" 内容类型 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = $event => form.contentType = 1),
            class: _normalizeClass(['px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer border', form.contentType === 1 ? 'bg-primary-50 text-primary-700 border-primary-300' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'])
          }, [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
            class: "flex items-center gap-1.5"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })]), _createTextVNode(" 图文 ")], -1)]))], 2), _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = $event => form.contentType = 2),
            class: _normalizeClass(['px-4 py-2 rounded-lg text-sm font-medium transition-colors cursor-pointer border', form.contentType === 2 ? 'bg-primary-50 text-primary-700 border-primary-300' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'])
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
            class: "flex items-center gap-1.5"
          }, [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          })]), _createTextVNode(" 短视频 ")], -1)]))], 2)])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "动态内容", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.content = $event),
            rows: "4",
            placeholder: "请输入动态文字内容",
            class: "form-textarea"
          }, null, 512), [[_vModelText, form.content]])]), isImageText.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_cache[19] || (_cache[19] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "图片（最多9张）", -1)), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingImages.value, (img, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "relative aspect-square rounded-lg overflow-hidden border border-slate-200 group"
            }, [_createElementVNode("img", {
              src: img.preview,
              class: "w-full h-full object-cover"
            }, null, 8, _hoisted_6), _createElementVNode("button", {
              onClick: $event => removeImage(index),
              class: "absolute top-1 right-1 flex h-5 w-5 items-center justify-center rounded-full bg-black/50 text-white hover:bg-red-500 transition-colors cursor-pointer opacity-0 group-hover:opacity-100"
            }, [...(_cache[17] || (_cache[17] = [_createElementVNode("svg", {
              class: "w-3 h-3",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M6 18L18 6M6 6l12 12"
            })], -1)]))], 8, _hoisted_7)]);
          }), 128)), pendingImages.value.length < 9 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: triggerImageUpload,
            class: "aspect-square border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center hover:border-primary-400 hover:bg-primary-50/30 transition-colors cursor-pointer"
          }, [...(_cache[18] || (_cache[18] = [_createElementVNode("svg", {
            class: "w-6 h-6 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createElementVNode("span", {
            class: "text-xs text-slate-400 mt-1"
          }, "添加图片", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("input", {
            ref_key: "imageInput",
            ref: imageInput,
            type: "file",
            accept: "image/*",
            multiple: "",
            class: "hidden",
            onChange: handleImageChange
          }, null, 544)])) : _createCommentVNode("", true), isVideo.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_cache[24] || (_cache[24] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, [_createTextVNode(" 视频 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), pendingVideoFile.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("video", {
            src: pendingVideoFile.value.preview,
            class: "w-full max-h-48 object-contain bg-black",
            controls: ""
          }, null, 8, _hoisted_10), _createElementVNode("button", {
            onClick: removeVideo,
            class: "absolute top-2 right-2 flex h-6 w-6 items-center justify-center rounded-full bg-black/50 text-white hover:bg-red-500 transition-colors cursor-pointer"
          }, [...(_cache[20] || (_cache[20] = [_createElementVNode("svg", {
            class: "w-3.5 h-3.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: triggerVideoUpload,
            class: "w-full h-36 border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center hover:border-primary-400 hover:bg-primary-50/30 transition-colors cursor-pointer"
          }, [...(_cache[21] || (_cache[21] = [_createElementVNode("svg", {
            class: "w-8 h-8 text-slate-400 mb-2",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          })], -1), _createElementVNode("span", {
            class: "text-sm text-slate-500"
          }, "点击上传视频", -1), _createElementVNode("span", {
            class: "text-xs text-slate-400 mt-1"
          }, "支持MP4格式，不超过100MB", -1)]))])), _createElementVNode("input", {
            ref_key: "videoInput",
            ref: videoInput,
            type: "file",
            accept: "video/*",
            class: "hidden",
            onChange: handleVideoChange
          }, null, 544), _cache[25] || (_cache[25] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2 mt-4"
          }, "视频封面", -1)), pendingCoverFile.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("img", {
            src: pendingCoverFile.value.preview,
            class: "h-24 rounded-lg border border-slate-200 object-cover"
          }, null, 8, _hoisted_12), _createElementVNode("button", {
            onClick: removeCover,
            class: "absolute -top-1.5 -right-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors cursor-pointer"
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-3 h-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])) : (_openBlock(), _createElementBlock("div", {
            key: 3,
            onClick: triggerCoverUpload,
            class: "w-32 h-24 border-2 border-dashed border-slate-300 rounded-lg flex flex-col items-center justify-center hover:border-primary-400 hover:bg-primary-50/30 transition-colors cursor-pointer"
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-5 h-5 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          })], -1), _createElementVNode("span", {
            class: "text-xs text-slate-400 mt-1"
          }, "上传封面", -1)]))])), _createElementVNode("input", {
            ref_key: "coverInput",
            ref: coverInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleCoverChange
          }, null, 544)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createVNode(OfficialPublisherPicker, {
            publishers: availablePublishers.value,
            "selected-id": selectedPublisherId.value,
            loading: publishersLoading.value,
            onSelect: handlePublisherSelect,
            onManage: _cache[3] || (_cache[3] = $event => showPublisherManageModal.value = true)
          }, null, 8, ["publishers", "selected-id", "loading"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", null, [_cache[26] || (_cache[26] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "展示名称", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.publisherName = $event),
            type: "text",
            placeholder: "如：官方运营（不填使用账号名称）",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.publisherName]])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "展示头像", -1)), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
            onClick: triggerAvatarUpload,
            class: "w-9 h-9 rounded-full border-2 border-dashed border-slate-300 flex items-center justify-center hover:border-primary-400 transition-colors cursor-pointer overflow-hidden shrink-0"
          }, [avatarPreview.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: avatarPreview.value,
            class: "w-full h-full object-cover"
          }, null, 8, _hoisted_15)) : (_openBlock(), _createElementBlock("svg", _hoisted_16, [...(_cache[27] || (_cache[27] = [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          }, null, -1)]))]))]), _cache[28] || (_cache[28] = _createElementVNode("span", {
            class: "text-xs text-slate-400"
          }, "不填使用默认头像", -1))]), _createElementVNode("input", {
            ref_key: "avatarInput",
            ref: avatarInput,
            type: "file",
            accept: "image/*",
            class: "hidden",
            onChange: handleAvatarChange
          }, null, 544)])])]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-3"
          }, "跳转链接", -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "链接URL", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.linkUrl = $event),
            type: "text",
            placeholder: "点击动态时跳转的链接地址",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.linkUrl]])]), _createElementVNode("div", _hoisted_19, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "链接标题", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.linkTitle = $event),
            type: "text",
            placeholder: "如：点击查看详情",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.linkTitle]])])])]), _createElementVNode("div", null, [_cache[37] || (_cache[37] = _createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900 mb-3"
          }, "置顶设置", -1)), _createElementVNode("div", _hoisted_20, [_createElementVNode("label", _hoisted_21, [_createElementVNode("input", {
            type: "checkbox",
            checked: form.isTop === 1,
            onChange: _cache[7] || (_cache[7] = $event => form.isTop = $event.target.checked ? 1 : 0),
            class: "w-4 h-4 text-primary-600 rounded border-slate-300 focus:ring-primary-500 cursor-pointer"
          }, null, 40, _hoisted_22), _cache[33] || (_cache[33] = _createElementVNode("span", {
            class: "text-sm text-slate-700"
          }, "发布后置顶", -1))]), form.isTop === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序值", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.topSort = $event),
            type: "number",
            min: "0",
            placeholder: "值越小越靠前",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.topSort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[35] || (_cache[35] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "过期时间", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.topExpireTime = $event),
            type: "datetime-local",
            class: "form-input w-full"
          }, null, 512), [[_vModelText, form.topExpireTime]]), _cache[36] || (_cache[36] = _createElementVNode("p", {
            class: "text-xs text-slate-400 mt-1"
          }, "不填则永不过期", -1))])])) : _createCommentVNode("", true)])])])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("button", {
            onClick: handleClose,
            class: "px-4 py-2 border border-slate-300 text-slate-700 rounded-lg text-sm hover:bg-slate-50 transition-colors cursor-pointer"
          }, " 取消 "), _createElementVNode("button", {
            onClick: handleSubmit,
            disabled: submitting.value,
            class: "btn-primary"
          }, _toDisplayString(submitting.value ? '发布中...' : '发布'), 9, _hoisted_25)])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })])), _createVNode(OfficialPublisherManageModal, {
        show: showPublisherManageModal.value,
        "onUpdate:show": _cache[10] || (_cache[10] = $event => showPublisherManageModal.value = $event),
        onChanged: handleManageChanged
      }, null, 8, ["show"])], 64);
    };
  }
};